import {
    HtmlIcon,
    CssIcon,
    JsIcon,
    ReactIcon,
    NodeIcon,
    GitIcon,
} from "../assets/icons";

export const devSkills = {
    htmlSkill: {
        id: 0,
        name: "HTML",
        icon: HtmlIcon,
        color: "primary",
    },
    cssSkill: {
        id: 1,
        name: "CSS",
        icon: CssIcon,
        color: "info",
    },
    jsSkill: {
        id: 2,
        name: "JavaScript",
        icon: JsIcon,
        color: "warning",
    },
    reactSkill: {
        id: 3,
        name: "React",
        icon: ReactIcon,
        color: "info",
    },
    nodeSkill: {
        id: 4,
        name: "NodeJS",
        icon: NodeIcon,
        color: "success",
    },
    gitSkill: {
        id: 5,
        name: "Git",
        icon: GitIcon,
        color: "secondary",
    },
};
